class CustomDialog extends HTMLElement {
  constructor() {
    
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
  }

  connectedCallback() {
    
    this.dialog = this.querySelector('dialog');
    const dataTargetValue = this.getAttribute('data-target'); 
    this.buttons = document.querySelectorAll(`button[data-target="${dataTargetValue}"]`);
    this.closeButton = this.querySelectorAll(`button[data-dialog="close"]`);

    if (!this.dialog) {
      console.error(`'${dataTargetValue}: Button or Dialog not found in DOM.'`);
      return
    }

    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleButtonClick);
    });

    this.closeButton.forEach(button => {
      button.addEventListener('click',() => {
        if (this.dialog.querySelector('.dialog')) {
          this.dialog.querySelector('.dialog')?.classList.add('fade-in');
        } else {
          this.dialog.classList.remove('fade-in');
        }
        this.dialog.close();
      });
    });

    this.dialog.addEventListener('click', this.handleDialogClose);

  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleButtonClick);
    }
    if (this.dialog) {
      this.dialog.removeEventListener('close', this.handleDialogClose);
    }
  }

  handleButtonClick() {
    if (!this.dialog) return

    const dialogToFadeIn = this.dialog.querySelector('.dialog') || this.dialog
    dialogToFadeIn.classList.add('fade-in');
    this.dialog.showModal();

  }

  handleDialogClose(event) {
    publish(PUB_SUB_EVENTS.popupClose)
    if (!this.dialog) return
    const rect = this.dialog.getBoundingClientRect();
    const isInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (isInDialog) return
    setTimeout(() =>{
        this.dialog.close();
    }, 400);

    if (this.dialog.querySelector('.dialog')) {
      this.dialog.querySelector('.dialog')?.classList.add('fade-in');
    } else {
      this.dialog.classList.remove('fade-in');
    }
  }

}
customElements.define('custom-dialog', CustomDialog);

class NewsletterDialog extends CustomDialog {
  constructor() {
    super();  
    this.subscribeHash = "#ContactFooter";
  }

  connectedCallback() {
    super.connectedCallback();
    this.checkForceOpenPop();
  }

  checkForceOpenPop(){
    const currentUrl = window.location.href;
    if (!currentUrl.includes(this.subscribeHash)) return
    this.handleButtonClick();
    history.replaceState(null, '', currentUrl.replace(this.subscribeHash,''));
  }
}

customElements.define('newsletter-dialog', NewsletterDialog);


class CountryDialog extends CustomDialog {
  constructor() {
    super();
    this.utils = new Utils();
  }

  connectedCallback() {
    super.connectedCallback();
    subscribe(PUB_SUB_EVENTS.countryPopupOpen, () => {
      this.handleButtonClick();
    })
  }


}

customElements.define('country-dialog', CountryDialog);


class ReturnDialog extends CustomDialog {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.setListeners();
  }

  setListeners() {
    this.querySelector('form').addEventListener('change', (event) => {
      this.toggleReason(event.target);
      const items = this.getItems();
      const submitBtn = this.querySelector('button[type="submit"]');
      !items.length ? submitBtn.setAttribute('disabled', 'true') : submitBtn.removeAttribute('disabled')
    })
    this.querySelector('form').addEventListener('submit', (event) => {
      event.preventDefault();
      const errorContainer = this.querySelector('[data-error-container]');
      errorContainer.toggleAttribute('hidden', true);
      this.handleReturn();
    });
    // "Altro": stessa regola del worker resi (altroValido in index.js), che comunque ricontrolla.
    this.querySelectorAll('[data-altro] textarea').forEach((area) => {
      const check = () => area.setCustomValidity(altroValido(area.value) ? '' : area.dataset.errore);
      area.addEventListener('input', check);
      check();
    });
  }

  // Il motivo compare solo per i capi spuntati; "Altro" apre il campo di testo.
  toggleReason(field) {
    if (field.type === 'checkbox') {
      const box = this.querySelector(`[data-motivo="${JSON.parse(field.value).id}"]`);
      if (box) box.hidden = box.disabled = !field.checked;
    }
    if (field.tagName === 'SELECT' && field.closest('[data-motivo]')) {
      const other = field.closest('[data-motivo]').querySelector('[data-altro]');
      other.hidden = other.disabled = field.value !== 'altro';
    }
  }

  reasonFor(id) {
    const box = this.querySelector(`[data-motivo="${id}"]`);
    if (!box) return {};
    const motivo = box.querySelector('select').value;
    return motivo === 'altro' ? { motivo, altro: box.querySelector('textarea').value } : { motivo };
  }

  getItems() {
    const formData = new FormData(this.querySelector('form'));
    return Object.values(Object.fromEntries(formData.entries())).map(value => JSON.parse(value));

  }

  handleReturn() {
    const body = {
      daAccount: true,
      numeroOrdine: this.querySelector('input[name="increment_id"]').value,
      articoli: this.getItems().map((item) => ({ lineItemId: item.id, quantita: item.qty_returned, ...this.reasonFor(item.id) })),
      lingua: document.documentElement.lang
    };

    this.makeRequests(body);
  }

  // Il reso passa dal worker resi (app proxy): verifica che l'ordine sia del cliente loggato, lo invia a STARK e lo registra.
  async makeRequests(body) {
    const submitBtn = this.querySelector('button[type="submit"]');
    submitBtn.setAttribute('disabled', 'true');
    try {
      const response = await fetch('/apps/returns/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const result = await response.json();
      if (!result.ok) throw { Message: result.message };

      const successContainer = this.querySelector('[data-success-container]');
      successContainer.toggleAttribute('hidden', false);

    } catch (error) {
      submitBtn.removeAttribute('disabled');
      this.errorHandler(error);
    }
  }

  errorHandler(error) {
    const errorContainer = this.querySelector('[data-error-container]');
    errorContainer.toggleAttribute('hidden', false);
    const errorMessage = error.Message || 'client.service@mc2saintbarth.com';

    errorContainer.querySelector('[data-error-message]').textContent = errorMessage;
  }
}

customElements.define('return-dialog', ReturnDialog);

// Copia di altroValido del worker resi (index.js): tenerle uguali.
function altroValido(testo) {
  var s = String(testo == null ? "" : testo).normalize("NFC").replace(/\s+/g, " ").trim();
  if (s.length > 300) return false;
  var lettere = (s.match(/\p{L}/gu) || []).join("").toLowerCase();
  var parole = s.toLowerCase().match(/\p{L}{2,}/gu) || [];
  var vuote = ["test", "prova", "niente", "nulla", "boh", "altro", "nessuno", "nessuna", "none", "nothing", "other", "xxx", "asd", "bla"];
  var vere = parole.filter(function (p) { return vuote.indexOf(p) < 0; });
  if (lettere.length < 8 || vere.length < 2 || new Set(vere).size < 2) return false;
  if (lettere.length / s.replace(/ /g, "").length < 0.7) return false;
  if (new Set(lettere).size < 5 || /(.)\1{3}/u.test(lettere)) return false;
  var vocali = (lettere.match(/[aeiouyàáâäèéêëìíîïòóôöùúûü]/g) || []).length;
  if (vocali / lettere.length < 0.2) return false;
  return !/qwer|wert|erty|rtyu|tyui|yuio|uiop|asdf|sdfg|dfgh|fghj|ghjk|hjkl|zxcv|xcvb|cvbn|vbnm/.test(lettere);
}